var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cmn-userform-view-container"},[(_vm.SubsysGUID)?_c('SubsysView',{ref:"SubSysView",on:{"onMount":_vm.OnMount}}):_c('SysView',{ref:"SysView",on:{"onMount":_vm.OnMount}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }